import { PunchupSendTickets } from 'features/PunchupPages/SendTickets';
import { PunchupSendTickets as LegacyPunchupSendTickets } from 'features/PunchupSendTickets';
import { SendTickets as SendTicketsComponent } from 'features/SendTickets';
import { useAppSelector } from 'store/hooks';

const SendTicketsPage = (): JSX.Element => {
	const { isPunchup, greenZoneEnabled } = useAppSelector((state) => state.auth);

	if (isPunchup && greenZoneEnabled) return <PunchupSendTickets />;
	if (isPunchup) return <LegacyPunchupSendTickets />;
	return <SendTicketsComponent />;
};
export default SendTicketsPage;
